import { getI18n as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: {
			users: {
				backButton: "Back to user list",
				email: "Email",
				name: "Name",
				resetPW: "Reset password",
				resetPWInfo: "An email with instructions to reset the password will be sent to the user.",
				reset2FA: "Reset 2-factor-authentication and password",
				reset2FAInfo: "An email with instructions to reset the password and two-factor authentication will be sent to the user.",
				saveAndCreate: "Save & create user",
				active: "Active",
				messageMandatoryInformation: "The user cannot be saved because mandatory information is missing.",
				messageUpdated: "User updated",
				messageCreated: "User created",
				messageBlocked: "User blocked",
				messageActive: "User active",
				requiredFields: "The user cannot be saved because mandatory information is missing.",
				router: { editUser: "Edit user" }
			},
			usersList: {
				title: "Users",
				newButton: "New user",
				search: "Search for user name or email",
				status: "Status",
				dpAny: "All",
				dpActive: "Active",
				dpInactive: "Blocked",
				loading: "Loading users",
				headerStatus: "Status",
				headerName: "Name",
				headerEmail: "Email",
				headerCreatedAt: "Creation date",
				headerLastLogin: "Last login",
				dpEdit: "Edit",
				dpBlock: "Block",
				dpUnblock: "Unblock"
			},
			additiveRightsList: {
				title: "Additive Rights",
				search: "Search by user name or email",
				filterRole: "Role Group",
				filterRight: "Additive Right",
				headerUser: "User",
				headerEmail: "Email",
				headerRole: "Role Group",
				headerRights: "Additive Rights",
				headerCount: "Count",
				headerLastModified: "Last Modified",
				headerActions: "Actions",
				emptyState: "No users have additive rights assigned. Additive rights can be granted on individual user detail pages.",
				removeConfirmTitle: "Remove additive right",
				removeConfirmMessage: "Do you really want to deprive {name} of the right to \"{right}\"?",
				removeSuccess: "Additive right removed",
				dpEdit: "Edit"
			},
			additiveRightsDetail: {
				sectionRegistryRights: "Registry Rights",
				searchPlaceholder: "Search module or right...",
				expandAll: "Expand all",
				collapseAll: "Collapse all",
				noMatches: "No module or right matches this search.",
				listTitle: "List of rights",
				moduleSelected: "{name} ({count} selected)"
			}
		},
		de: {
			users: {
				backButton: "Zurück zur Nutzerliste",
				email: "E-Mail-Adresse",
				name: "Name",
				resetPW: "Passwort zurücksetzen",
				resetPWInfo: "Der Nutzer erhält eine E-Mail mit Informationen zum Zurücksetzen des Passworts.",
				reset2FA: "2-Faktor-Authentifizierung und Passwort zurücksetzen",
				reset2FAInfo: "Der Nutzer erhält eine E-Mail mit Anweisungen zum Zurücksetzen von Passwort und Zwei-Faktor-Authentifizierung.",
				saveAndCreate: "Speichern & Nutzer erstellen",
				active: "Aktiv",
				messageMandatoryInformation: "Der Nutzer kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
				messageUpdated: "Nutzer aktualisiert",
				messageCreated: "Nutzer erstellt",
				messageBlocked: "Nutzer gesperrt",
				messageActive: "Nutzer aktiv",
				requiredFields: "Der Nutzer kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
				router: { editUser: "Nutzer bearbeiten" }
			},
			usersList: {
				title: "Nutzer",
				newButton: "Neuer Nutzer",
				search: "Suchen nach Nutzername oder E-Mail-Adresse",
				status: "Status",
				dpAny: "Alle",
				dpActive: "Aktiv",
				dpInactive: "Gesperrt",
				loading: "Lade Nutzer",
				headerStatus: "Status",
				headerName: "Name",
				headerEmail: "E-Mail-Adresse",
				headerCreatedAt: "Erstellungsdatum",
				headerLastLogin: "Letzter Login",
				dpEdit: "Bearbeiten",
				dpBlock: "Sperren",
				dpUnblock: "Entsperren"
			},
			additiveRightsList: {
				title: "Zusatzrechte",
				search: "Nach Nutzername oder E-Mail suchen",
				filterRole: "Rollengruppe",
				filterRight: "Zusatzrecht",
				headerUser: "Nutzer",
				headerEmail: "E-Mail",
				headerRole: "Rollengruppe",
				headerRights: "Zusatzrechte",
				headerCount: "Anzahl",
				headerLastModified: "Letzte Änderung",
				headerActions: "Aktionen",
				emptyState: "Keine Nutzer haben Zusatzrechte zugewiesen. Zusatzrechte können auf den einzelnen Nutzerdetailseiten vergeben werden.",
				removeConfirmTitle: "Zusatzrecht entfernen",
				removeConfirmMessage: "Möchtest du {name} wirklich das Recht „{right}\" entziehen?",
				removeSuccess: "Zusatzrecht entfernt",
				dpEdit: "Bearbeiten"
			},
			additiveRightsDetail: {
				sectionRegistryRights: "Registry-Rechte",
				searchPlaceholder: "Modul oder Recht suchen...",
				expandAll: "Alle ausklappen",
				collapseAll: "Alle einklappen",
				noMatches: "Kein Modul und kein Recht passt zu dieser Suche.",
				listTitle: "Liste der Rechte",
				moduleSelected: "{name} ({count} ausgewählt)"
			}
		}
	},
	routes: [{
		path: "/users",
		children: [
			{
				path: "",
				name: "user_list",
				component: () => import("./users-list.view-BwuEAk3v.js"),
				meta: { requiredRight: "users:navigate" }
			},
			{
				path: "additive-rights",
				name: "additive_rights_list",
				component: () => import("./additive-rights-list.view-NbXMVGs1.js"),
				meta: { requiredRight: "users:navigate" }
			},
			{
				path: ":id",
				name: "user_detail",
				component: () => import("./user-edit-DoPriQCI.js"),
				meta: { requiredRight: "users:navigate" },
				props: () => ({ title: e().t("users.router.editUser") })
			}
		]
	}]
};
//#endregion
export { t as userModule };

//# sourceMappingURL=index.es.js.map